// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCGt8KUwbZbZweHVPy2fkMNgB8rYXvshxs',
    authDomain: 'finflowito.firebaseapp.com',
    projectId: 'finflowito',
    storageBucket: 'finflowito.appspot.com',
    messagingSenderId: '517090086704',
    appId: '1:517090086704:web:eb13d193a982cda302c2f5',
    measurementId: 'G-C63KD069LD'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
